module.exports = __webpack_public_path__ + "assets/img/smartTV2-icon3.2257b9ae.svg";